import React, { useState, useEffect } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
const Cateringordersdetails = () => {
    const [showDetails, setShowDetails] = useState({});
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    const handleSendApproval = async (order) => {
        const orderId = order.orderId || order.id; // fallback if orderId missing
        if (!orderId) {
            alert("❌ Order ID missing!");
            return;
        }

        const authToken = localStorage.getItem("authToken");
        const bodyData = {
            adminPermision: true,
            paymentAmount: Number(order.paymentAmount) || 0,
        };

        // ✅ Print URL and body data in console
        // console.log("Sending approval with URL:", `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/approval/${orderId}`);
        // console.log("Request body:", bodyData);

        try {
            showLoader();
            const response = await fetch(
                `http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/approval/${orderId}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${authToken}`,
                    },
                    body: JSON.stringify(bodyData),
                }
            );

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! Status: ${response.status}, Response: ${errorText}`);
            }

            const data = await response.json();
            // console.log("✅ Approval Response:", data);
            alert(`Approval sent successfully!`);
        } catch (err) {
            console.error("Error sending approval:", err);
            alert("Failed to send approval. See console for details.");
        } finally {
            hideLoader();
        }
    };



    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            setError(null);

            try {
                showLoader();
                const authToken = localStorage.getItem("authToken");
                if (!authToken) throw new Error("No auth token found. Please login.");

                const response = await fetch(
                    "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/all",
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                            Accept: "*/*",
                        },
                    }
                );

                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const data = await response.json();

                // ✅ Filter only items where adminPermision === false
                const filteredData = Array.isArray(data)
                    ? data.filter((item) => item.adminPermision === false)
                    : [];

                setOrders(filteredData);
                localStorage.setItem("ordersData", JSON.stringify(filteredData));
            } catch (err) {
                console.error("Error fetching orders:", err);
                setError("Failed to load orders.");

                const storedOrders = localStorage.getItem("ordersData");
                if (storedOrders) {
                    setOrders(JSON.parse(storedOrders));
                    // console.log("✅ Loaded orders from localStorage");
                }
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchOrders();
    }, []);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const styles = {
        card: {
            border: '1px solid #ccc',
            padding: '16px',
            margin: '16px',
            borderRadius: '10px',
            background: "linear-gradient(to right, #f46b45, #eea849)"
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '10px'
        },
        orderId: { margin: 0, fontWeight: "bold" },
        detailsRow: { display: 'flex', gap: '20px', fontSize: '14px', fontWeight: "bold" },
        pickupBtn: {
            background: '#28a745',
            color: '#fff',
            border: 'none',
            padding: '6px 12px',
            cursor: 'pointer',
            borderRadius: '5px',
            fontWeight: "bold"
        },
        dropdownBtn: { background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer' },
    };

    if (loading) return <div>Loading orders...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div>
            {orders.map((order) => {
                const orderItems = order.items || [];
                const orderId = order.id;

                // Total plates calculation
                const totalPlates = (order.vegPlates || 0) + (order.nonVegPlates || 0) + (order.mixedPlates || 0);

                return (
                    <div key={orderId} style={styles.card}>
                        {/* ===== Header ===== */}
                        <div style={styles.header}>
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                    <h3 style={styles.orderId}>Order ID: {orderId}</h3>
                                </div>
                            </div>

                            <button
                                style={styles.dropdownBtn}
                                onClick={() =>
                                    setShowDetails((prev) => ({
                                        ...prev,
                                        [orderId]: !prev[orderId],
                                    }))
                                }
                            >
                                {showDetails[orderId] ? '▲' : '▼'}
                            </button>
                        </div>

                        <div
                            style={{
                                background: "linear-gradient(to right, rgb(244 107 68), rgb(238, 168, 73))",
                                padding: "15px",
                                borderRadius: "5px",
                                display: "flex",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                color: "#000",
                                fontSize: "18px",
                                gap: "40px",
                            }}
                        >
                            {/* Left Column */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Event Type</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{order.eventType}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Date</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{formatDate(order.eventDate)}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Time</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{order.eventTime}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Plates</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{totalPlates}</span>
                                </div>
                            </div>

                            {/* Right Column */}
                            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Name</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{order.fullName}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Mobile</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{order.phoneNumber}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Email</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>{order.email}</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "flex-start", gap: "6px" }}>
                                    <span style={{ minWidth: "120px", fontWeight: "bold" }}>Location</span>
                                    <span style={{ minWidth: "10px" }}>:</span>
                                    <span>
                                        {order.fullAddress}<br />
                                        {order.city}<br />
                                        {order.state}<br />
                                        {order.country}
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* ===== Expanded Details ===== */}
                        {showDetails[orderId] && (
                            <>
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '1rem' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#b15cd6', textAlign: 'center' }}>
                                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Items</th>
                                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Veg Plates</th>
                                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Non-Veg Plates</th>
                                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Mixed Plates</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.items.map((item, index) => (
                                            <tr key={index} style={{ borderBottom: '1px solid #eee', fontWeight: 'bold', backgroundColor: '#d4edda' }}>
                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item}</td>
                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{order.vegPlates}</td>
                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{order.nonVegPlates}</td>
                                                <td style={{ padding: '8px', border: '1px solid #ddd' }}>{order.mixedPlates}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', justifyContent: 'space-between', marginBottom: "40px" }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: "20px" }}>
                                        <span style={{ fontWeight: 'bold' }}>Grand Total:</span>
                                        <span style={{ fontWeight: 'bold' }}>{order.budget}</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: "20px" }}>
                                        <span style={{ fontWeight: 'bold' }}>Including Lead Price:</span>
                                        <span style={{ fontWeight: 'bold' }}>{order.paymentAmount}</span>
                                    </div>
                                    <button
                                        style={{
                                            ...styles.pickupBtn,
                                            backgroundColor: order.adminPermision ? "#ccc" : "#199c58ff", // ✅ gray if disabled, green if active
                                            cursor: order.adminPermision ? "not-allowed" : "pointer",
                                        }}
                                        onClick={() => handleSendApproval({ ...order, orderId: order.id })}
                                        disabled={order.adminPermision === true}
                                    >
                                        Approve
                                    </button>



                                </div>
                            </>
                        )}

                    </div>
                );
            })}
        </div>
    );
};

export default Cateringordersdetails;
